// «Evenimentele proiectului»: ce s-a întâmplat, cel mai nou sus — panoul din
// dreapta al paginii Soluții cât nu e ales niciun rând.
//
// Rândurile le compune serverul din joburi, soluții, cereri de modificări și
// jurnalul proiectului (`api/structure.py::feed`), deci aici nu se amestecă și
// nu se decide nimic: un punct în culoarea `clasa`, ora și propoziția gata
// scrisă. Duratele (subsolul refăcut, rampele, adăposturile ALA) vin în
// propoziția evenimentului, de aceea ora are și secunde.
//
// Sondajul urmează registrul: 3 s cât rulează ceva, altfel 30 s; o filă
// ascunsă nu cere nimic.

import { useCallback, useEffect, useState } from "react";
import * as api from "../api";
import { dataOra, ora, useT } from "../i18n";
import { areRulari, useRegistru } from "../nav/Registru";

const PUNCT: Record<string, string> = {
  ok: "var(--ok)",
  bad: "var(--bad)",
  feedback: "var(--met)",
};

const eAzi = (iso: string) => new Date(iso).toDateString() === new Date().toDateString();

export default function EvenimenteProiect() {
  const t = useT();
  const { projectId, registru } = useRegistru();
  const [evenimente, setEvenimente] = useState<api.FeedEvent[] | null>(null);
  const [eroare, setEroare] = useState(false);
  const viu = areRulari(registru);

  const citeste = useCallback(async () => {
    try {
      setEvenimente(await api.getFeed(projectId));
      setEroare(false);
    } catch {
      setEroare(true);
    }
  }, [projectId]);

  // `registru` în dependențe: un sondaj al registrului care aduce ceva nou
  // (un rând gata, o rulare pornită) aduce și evenimentele, fără să aștepte
  // ceasul de 30 s
  useEffect(() => {
    let oprit = false;
    const ia = () => { if (!oprit && !document.hidden) void citeste(); };
    void citeste();
    const tic = setInterval(ia, viu ? 3_000 : 30_000);
    document.addEventListener("visibilitychange", ia);
    return () => {
      oprit = true;
      clearInterval(tic);
      document.removeEventListener("visibilitychange", ia);
    };
  }, [citeste, viu, registru]);

  return (
    <aside className="ans-previzualizare ans-evenimente" aria-label={t("evenimente.titlu")}>
      <div className="ans-evenimente-cap">
        <h2 className="disp">{t("evenimente.titlu")}</h2>
        <span className="lbl">{t(viu ? "evenimente.viu" : "evenimente.repaus")}</span>
      </div>
      <p className="note">{t("ansamblu.alege_rand")}</p>
      {eroare && <p className="note bad">{t("evenimente.esec")}</p>}
      {evenimente === null && !eroare && <p className="note">{t("comun.se_incarca")}</p>}
      {evenimente?.length === 0 && <p className="note">{t("evenimente.gol")}</p>}
      <ol className="ans-evenimente-lista">
        {evenimente?.map((e, i) => (
          <li key={`${e.la}-${i}`} className="ans-eveniment">
            <span className="dot" style={{ background: PUNCT[e.clasa] ?? "var(--acc)" }} />
            <div>
              <span className="lbl" title={dataOra(e.la)}>
                {eAzi(e.la)
                  ? ora(e.la, { hour: "2-digit", minute: "2-digit", second: "2-digit" })
                  : dataOra(e.la)}
              </span>
              <div className="ans-eveniment-text">{e.mesaj}</div>
            </div>
          </li>
        ))}
      </ol>
    </aside>
  );
}
